import { createAction, union } from '@ngrx/store';
import { Reservation } from 'src/app/models/reservation/reservation';

export const updateLoading = createAction(
  'ReservationActions updateLoading',
  (payload: boolean) => ({ payload }),
);

export const storeErrorMessage = createAction(
  'ReservationActions storeErrorMessage',
  (payload: string) => ({ payload }),
);

export const storeReservation = createAction(
  'ReservationActions storeReservation',
  (payload: Reservation) => ({ payload }),
);

export const resetState = createAction('ReservationActions resetState');

const all = union({
  updateLoading,
  storeReservation,
  resetState,
});

export type ReservationActionsUnion = typeof all;
